import React, { useState, useEffect } from "react";
import styles from "./AddItem.module.scss";
import classNames from "classnames/bind";
import { SearchIcon, MapPinIcon, PlusIcon } from "~/assets/icons";

const cx = classNames.bind(styles);

interface AddItemProps {
    label?:string,
    onClick: () => void;
    disable?:boolean
}

const AddItem: React.FC<AddItemProps> = ({
label, onClick, disable
}) => {

  return (
        <>
            <div className={cx({
                'btn-add':true
            })} onClick={onClick}>
                <PlusIcon className="w-[14px] h-[14px] [&>path]:fill-[#2D80FC]"  color="#2D80FC" />
                <span>{label ? label : 'Add Item'}</span>
            </div>
        </>
  );
};

export default AddItem;

